<template>
  <div class="TcnTransformTextField">
    <p v-if="!showInput"
       @click="showInput=true"
       style="cursor: pointer"
       class="pa-0 mr-auto">
      Dodaj uwagę
    </p>
    <v-text-field v-else
                  v-model="localModel"
                  v-bind="localProps"
                  :placeholder="localLabel"
                  :disabled="disabled || localProps.disabled"
                  append-icon="mdi-close"
                  @click:append="clearAndClose"
    >

    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "TcnTransformTextField",
  components: {},
  props: {
    value: {default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {
      showInput: false
    }
  },
  computed: {
    localModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', {key: this.fullKey, value: val !== "" ? val : null})
      },
    },

    localText() {
      return this.schema['text'] || "Brak definicji text"
    },

    localProps() {
      const global = this.options['fieldProps']
      const textField = this.options['textFieldProps'] !== undefined && this.options['textFieldProps'] !== null ? this.options['textFieldProps'] : {}
      const forThis = this.schema['x-props'] !== undefined && this.schema['x-props'] !== null ? this.schema['x-props'] : {}
      let result = global !== undefined && global !== null ? global : {}
      result = {...result, ...textField}
      result = {...result, ...forThis}

      if (this.schema["readOnly"]) {
        result = {...result, ...{outlined: false, filled: false}}
      }

      console.log(result)
      return result
    },

    localLabel() {
      return this.schema['label'] || null
    },


  },
  watch: {
    localModel: function (n, o) {
      if (n === null) {
        this.showInput = false
      }
    }
  },
  methods: {
    clearAndClose() {
      this.localModel = null
      this.showInput = false
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="css">

</style>
